import styled, { useTheme } from 'styled-components';
import { Heading2Text } from '../../../../components/Texts';
import ColorizedSpan from '../../../../components/Colorized';
import {
  PHONE_MEDIA_QUERY,
  useMediaQuery,
} from '../../../../common/responsive';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: fit-content;
  min-height: 750px;
  padding-bottom: 60px;
  gap: 30px;
  @media ${PHONE_MEDIA_QUERY} {
    min-height: unset;
    overflow: hidden;
    padding-top: 0px;
    padding-bottom: 30px;
  }
`;

const SubTitle = styled.p`
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => theme.text.title};
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  @media ${PHONE_MEDIA_QUERY} {
    gap: 0px;
  }
`;

const VideoColumn = styled.div`
  flex: 1;
  aspect-ratio: 16/9;
  width: 100%;
`;

const YoutubeVideo = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  return (
    <Container>
      <TitleContainer>
        <Heading2Text style={{ color: theme.text.title }}>
          How it <ColorizedSpan>Works</ColorizedSpan>
        </Heading2Text>
      </TitleContainer>
      <VideoColumn>
        <VideoColumn>
          <iframe
            style={{ width: '100%', height: '100%' }}
            src='https://www.youtube.com/embed/1Ve4Y7ZITX8'
            title='YouTube video player'
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            referrerPolicy='strict-origin-when-cross-origin'
            allowFullScreen
          ></iframe>
        </VideoColumn>
      </VideoColumn>
    </Container>
  );
};

export default YoutubeVideo;
